import {CompanyDepartmentsResponse, CompanyDepartmentsJSON, SubdepartmentJSON} from '../types';

export default class CompanyDepartmentsSerializer {
  static toObject(payload: CompanyDepartmentsJSON): {
    companyDepartments: CompanyDepartmentsResponse['companyDepartments'];
  } {
    return {
      companyDepartments: payload.company_departments?.map((department) => ({
        resourceId: department.resource_id,
        name: {
          en: department.name.en,
          de: department.name.de,
        },
        methodDepartmentCategory: department.method_department_category
          ? {
            resourceId: department.method_department_category.resource_id,
            name: {
              en: department.method_department_category.name.en,
              de: department.method_department_category.name.de,
            },
          }
          : undefined,
        methodTextProfile: department.method_text_profile,
        subdepartments: department.subdepartments?.map((subdepartment: SubdepartmentJSON) => ({
          resourceId: subdepartment.resource_id,
          name: {
            en: subdepartment.name.en,
            de: subdepartment.name.de,
          },
        })),
      })),
    };
  }
}
